import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import {
  Chip,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { MdArrowBackIosNew } from 'react-icons/md';
import { getXperienceGroupRecordsApi } from "../../api's/DataProcessorApi";
import LoadingIcon from '../../reusable-component/LoadingIcon';
import { convertToPascalCase } from '../../utils/stringConversion';

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} {...props} />)(({ theme }) => ({
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.5rem' }} />} {...props} />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const GroupRecords = ({ handleSource, selectedRow, sources, selectedSource, prevNodeId }) => {
  const { enqueueSnackbar } = useSnackbar();
  console.log({ selectedRow });
  const [loading, setLoading] = useState(false);
  const [groupRecords, setGroupRecords] = useState([]);
  const [tableData, setTableData] = useState([]);

  const fetchGroupRecords = async () => {
    setLoading(true);
    try {
      const data = {
        // client_name: workflow.engagement.client.client_name,
        // engagement_name: workflow.engagement.engagement_name,
        // workflow_name: workflow.workflow_name,
        nodeId: prevNodeId,
        groupId: selectedRow.group_id,
      };
      const response = await getXperienceGroupRecordsApi(data);
      if (response.status === 200) {
        setGroupRecords(response.data);
        setTableData(Object.entries(response.data.grouping_records));
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (error.response?.status === 404) {
        enqueueSnackbar('404 Group Records not found!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchGroupRecords();
  }, []);

  const handleChipColor = (ele) => {
    if (selectedSource.length > 0) {
      if (selectedSource === ele.source) {
        return sources.find((item) => item.source === ele.source)?.color ?? '#e0e0e0';
      }
      return '#fafafa';
    }
    return sources.find((item) => item.source === ele.source)?.color ?? '#e0e0e0';
  };

  function getRuleType(attribute) {
    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    console.log(getAllNodes);
    return getAllNodes
      ?.find((item) => item.nodeName === 'Match & Merge')
      ?.fetchedHeader?.find((item) => item.header === attribute)?.merge_rule;
  }

  return (
    <>
      <Stack direction="row" my={1} alignItems="center">
        <IconButton size="small" aria-label="back" onClick={handleSource}>
          <MdArrowBackIosNew />
        </IconButton>
        <FaUserCircle size="65" color={grey[300]} />
        <Stack direction="column" ml={1}>
          <Typography variant="body1" display="block" fontWeight={600}>
            {selectedRow.cust_name || selectedRow.PatientName || selectedRow.asset_name}
          </Typography>
          <Typography variant="caption" display="block">
            {selectedRow.cust_ship_to_address || selectedRow.asset_type}
          </Typography>
          <Typography variant="caption" component="div">
            <Chip label="Individual" color="primary" size="small" sx={{ mr: 1, fontSize: 12 }} />
            Entity ID: {groupRecords.group_id ?? '--'}
          </Typography>
        </Stack>
      </Stack>
      <TableContainer sx={{ maxHeight: 400 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Attributes</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Rule Type</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Count</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Attribute Values</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Golden Record</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData
              .filter((item) => item[0] !== 'index' && item[0] !== 'group_id' && item[0] !== 'image_data')
              .map((item) => (
                <>
                  <TableRow component="th" scope="row" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell>{convertToPascalCase(item[0])}</TableCell>
                    <TableCell>{getRuleType(item[0]) ?? '--'}</TableCell>
                    <TableCell>{item[1]?.length}</TableCell>
                    <TableCell>
                      {item[1]?.map(
                        (ele, index) =>
                          ele.value !== 'null' && (
                            <Chip
                              label={ele.value}
                              size="small"
                              sx={{
                                mr: 1,
                                mb: 0.3,
                                fontSize: 12,
                                bgcolor: handleChipColor(ele),
                              }}
                            />
                          )
                      )}
                    </TableCell>
                    <TableCell>{selectedRow[item[0]]}</TableCell>
                  </TableRow>
                </>
              ))}
          </TableBody>
        </Table>
        {loading && <LoadingIcon />}
      </TableContainer>
      {/* <PotentialMatches row={row} /> */}
    </>
  );
};

export default GroupRecords;
